const initialState = {
  sphereMotivosList: [],
  clientContactEmailsList: [],
  invoiceDevolutionList: [],
  invoiceDevolutionDetails: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SPHERE_MOTIVOS_LIST':
      return {
        ...state,
        sphereMotivosList: action.sphereMotivos,
      };
    case 'SET_CLIENT_CONTACT_EMAILS_LIST':
      return {
        ...state,
        clientContactEmailsList: action.clientContactEmails,
      };
    case 'SET_INVOICE_DEVOLUTION_LIST':
      return {
        ...state,
        invoiceDevolutionList: action.invoiceDevolutionList,
      };
    case 'SET_INVOICE_DEVOLUTION_DETAILS':
      return {
        ...state,
        invoiceDevolutionDetails: action.invoiceDevolutionDetails,
      };
    default:
      return state;
  }
};
